// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Tagesablauf ─── */

.tagesablauf-container {
  max-width: 1100px;
  margin: 0 auto;
  padding-bottom: 2rem;
}

/* Feste Maße der Gantt-Tabelle: Beschriftungsspalte + Zeitachse 7–24 Uhr */
.ta-chart {
  --ta-label-breite: 150px;
  --ta-track-breite: 850px;
}

/* ─── Tages-Tabs (wie Speiseplan) ─── */

.tagesablauf-tabs {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding: 4px 0 12px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.tagesablauf-tabs::-webkit-scrollbar {
  display: none;
}

.tagesablauf-tab {
  flex: 0 0 auto;
  padding: 8px 14px;
  border-radius: 20px;
  border: 2px solid var(--dunkelgruen);
  background-color: transparent;
  color: var(--dunkelgruen);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.95em;
  white-space: nowrap;
  margin: 0;
  width: auto;
}

.tagesablauf-tab:hover {
  background-color: var(--hellgruen);
  opacity: 1;
}

.tagesablauf-tab.active {
  background-color: var(--dunkelgruen);
  color: var(--weiss);
  border-color: var(--dunkelgruen);
}

body.Arbeit-Freizeit .tagesablauf-tab.active {
  background-color: var(--orange);
  border-color: var(--orange);
}

body.Parlament .tagesablauf-tab.active {
  background-color: var(--gelb);
  border-color: var(--gelb);
}

body.Logistik .tagesablauf-tab.active {
  background-color: var(--mittelblau);
  border-color: var(--mittelblau);
}

body.Arbeit-Freizeit .tagesablauf-tab:not(.active) {
  border-color: var(--orange);
  color: var(--orange);
}

body.Parlament .tagesablauf-tab:not(.active) {
  border-color: var(--gelb);
  color: var(--gelb);
}

body.Logistik .tagesablauf-tab:not(.active) {
  border-color: var(--mittelblau);
  color: var(--mittelblau);
}

.tagesablauf-tagestitel {
  color: var(--dunkelgruen);
  margin: 6px 0 4px;
}

.tagesablauf-jetzt-hinweis {
  font-family: 'Circular', sans-serif;
  font-size: 0.85em;
  color: #d92b2b;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-bottom: 8px;
}

.jetzt-punkt {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: #d92b2b;
  display: inline-block;
  animation: jetztPulsieren 2s ease-in-out infinite;
}

@keyframes jetztPulsieren {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}

/* ─── Gantt-Tabelle ─── */

.ta-chart-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid rgba(100, 130, 2, 0.35);
  border-radius: 10px;
  background-color: #fff;
  /* Platz, damit die "24" der Stundenleiste nicht abgeschnitten wird */
  padding-right: 10px;
}

.ta-chart {
  width: calc(var(--ta-label-breite) + var(--ta-track-breite));
  min-width: 100%;
}

.ta-row {
  display: flex;
  align-items: stretch;
}

.ta-row-label {
  flex: 0 0 var(--ta-label-breite);
  width: var(--ta-label-breite);
  position: sticky;
  left: 0;
  z-index: 3;
  background-color: var(--blassgruen);
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 0.72em;
  font-weight: bold;
  text-align: left;
  padding: 6px 8px;
  border-bottom: 1px solid rgba(100, 130, 2, 0.25);
  border-right: 2px solid rgba(100, 130, 2, 0.4);
  display: flex;
  align-items: center;
  line-height: 1.2;
  overflow-wrap: break-word;
  word-break: break-word;
}

.ta-row-track {
  flex: 0 0 var(--ta-track-breite);
  width: var(--ta-track-breite);
  position: relative;
  min-height: 30px;
  border-bottom: 1px solid rgba(100, 130, 2, 0.25);
  /* Stundenraster: kräftige Linie pro Stunde, zarte Linie pro halbe Stunde */
  background-image:
    repeating-linear-gradient(
      to right,
      rgba(100, 130, 2, 0.28) 0,
      rgba(100, 130, 2, 0.28) 1px,
      transparent 1px,
      transparent calc(var(--ta-track-breite) / 17)
    ),
    repeating-linear-gradient(
      to right,
      transparent 0,
      transparent calc(var(--ta-track-breite) / 34 - 1px),
      rgba(100, 130, 2, 0.12) calc(var(--ta-track-breite) / 34 - 1px),
      rgba(100, 130, 2, 0.12) calc(var(--ta-track-breite) / 34)
    );
}

/* ─── Kopfzeile ─── */

.ta-header-row .ta-header-label {
  font-size: 0.75em;
}

.ta-header-track {
  min-height: 26px;
  background-image: none;
}

.ta-stunde {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: 'Circular', sans-serif;
  font-size: 0.7em;
  font-weight: bold;
  color: var(--dunkelgruen);
}

.ta-header-row .ta-row-label,
.ta-header-track {
  border-bottom: 2px solid rgba(100, 130, 2, 0.4);
}

/* ─── Zeitslots ─── */

.ta-body {
  position: relative;
}

.ta-slot {
  position: absolute;
  top: 4px;
  bottom: 4px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.ta-slot-label {
  font-family: 'Circular', sans-serif;
  font-size: 0.62em;
  font-weight: bold;
  color: #fff;
  white-space: nowrap;
  padding: 0 3px;
  text-shadow: 0 0 3px rgba(0, 0, 0, 0.55);
}

/* ─── Roter "Jetzt"-Balken über die ganze Tabelle ─── */

.ta-jetzt-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: var(--ta-label-breite);
  width: var(--ta-track-breite);
  pointer-events: none;
  z-index: 2;
}

.ta-jetzt-balken {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 3px;
  margin-left: -1.5px;
  background-color: #e11515;
  box-shadow: 0 0 6px rgba(225, 21, 21, 0.6);
}

.ta-jetzt-balken::before {
  content: '';
  position: absolute;
  top: -1px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid #e11515;
}

/* ─── Leer-Zustand ─── */

.tagesablauf-empty {
  text-align: center;
  padding: 40px 20px;
  color: var(--primary-dark);
  font-family: 'Circular', sans-serif;
}

.tagesablauf-empty .material-symbols-outlined {
  font-size: 3rem;
  margin-bottom: 10px;
  opacity: 0.5;
}

.tagesablauf-empty p {
  font-size: 0.95em;
}

/* Auf schmalen Bildschirmen bleibt die Tabelle horizontal scrollbar,
   die Beschriftungsspalte wird etwas schmaler */
@media (max-width: 600px) {
  .ta-chart {
    --ta-label-breite: 110px;
    --ta-track-breite: 680px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/tagesablauf/Tagesablauf.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA,2EAA2E;AAC3E;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA,wCAAwC;;AAExC;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB;;AAEA,0BAA0B;;AAE1B;EACE,gBAAgB;EAChB,iCAAiC;EACjC,yCAAyC;EACzC,mBAAmB;EACnB,sBAAsB;EACtB,qEAAqE;EACrE,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;EAC5D,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,mCAAmC;EACnC,yBAAyB;EACzB,mCAAmC;EACnC,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;EAChD,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;EAChD,2EAA2E;EAC3E;;;;;;;;;;;;;;KAcG;AACL;;AAEA,sBAAsB;;AAEtB;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA,sBAAsB;;AAEtB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA,wDAAwD;;AAExD;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,yBAAyB;;AAEzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;gDACgD;AAChD;EACE;IACE,wBAAwB;IACxB,wBAAwB;EAC1B;AACF","sourcesContent":["/* ─── Tagesablauf ─── */\n\n.tagesablauf-container {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding-bottom: 2rem;\n}\n\n/* Feste Maße der Gantt-Tabelle: Beschriftungsspalte + Zeitachse 7–24 Uhr */\n.ta-chart {\n  --ta-label-breite: 150px;\n  --ta-track-breite: 850px;\n}\n\n/* ─── Tages-Tabs (wie Speiseplan) ─── */\n\n.tagesablauf-tabs {\n  display: flex;\n  gap: 6px;\n  overflow-x: auto;\n  padding: 4px 0 12px;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.tagesablauf-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.tagesablauf-tab {\n  flex: 0 0 auto;\n  padding: 8px 14px;\n  border-radius: 20px;\n  border: 2px solid var(--dunkelgruen);\n  background-color: transparent;\n  color: var(--dunkelgruen);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.95em;\n  white-space: nowrap;\n  margin: 0;\n  width: auto;\n}\n\n.tagesablauf-tab:hover {\n  background-color: var(--hellgruen);\n  opacity: 1;\n}\n\n.tagesablauf-tab.active {\n  background-color: var(--dunkelgruen);\n  color: var(--weiss);\n  border-color: var(--dunkelgruen);\n}\n\nbody.Arbeit-Freizeit .tagesablauf-tab.active {\n  background-color: var(--orange);\n  border-color: var(--orange);\n}\n\nbody.Parlament .tagesablauf-tab.active {\n  background-color: var(--gelb);\n  border-color: var(--gelb);\n}\n\nbody.Logistik .tagesablauf-tab.active {\n  background-color: var(--mittelblau);\n  border-color: var(--mittelblau);\n}\n\nbody.Arbeit-Freizeit .tagesablauf-tab:not(.active) {\n  border-color: var(--orange);\n  color: var(--orange);\n}\n\nbody.Parlament .tagesablauf-tab:not(.active) {\n  border-color: var(--gelb);\n  color: var(--gelb);\n}\n\nbody.Logistik .tagesablauf-tab:not(.active) {\n  border-color: var(--mittelblau);\n  color: var(--mittelblau);\n}\n\n.tagesablauf-tagestitel {\n  color: var(--dunkelgruen);\n  margin: 6px 0 4px;\n}\n\n.tagesablauf-jetzt-hinweis {\n  font-family: 'Circular', sans-serif;\n  font-size: 0.85em;\n  color: #d92b2b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.jetzt-punkt {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background-color: #d92b2b;\n  display: inline-block;\n  animation: jetztPulsieren 2s ease-in-out infinite;\n}\n\n@keyframes jetztPulsieren {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.35; }\n}\n\n/* ─── Gantt-Tabelle ─── */\n\n.ta-chart-scroll {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  border: 1px solid rgba(100, 130, 2, 0.35);\n  border-radius: 10px;\n  background-color: #fff;\n  /* Platz, damit die \"24\" der Stundenleiste nicht abgeschnitten wird */\n  padding-right: 10px;\n}\n\n.ta-chart {\n  width: calc(var(--ta-label-breite) + var(--ta-track-breite));\n  min-width: 100%;\n}\n\n.ta-row {\n  display: flex;\n  align-items: stretch;\n}\n\n.ta-row-label {\n  flex: 0 0 var(--ta-label-breite);\n  width: var(--ta-label-breite);\n  position: sticky;\n  left: 0;\n  z-index: 3;\n  background-color: var(--blassgruen);\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.72em;\n  font-weight: bold;\n  text-align: left;\n  padding: 6px 8px;\n  border-bottom: 1px solid rgba(100, 130, 2, 0.25);\n  border-right: 2px solid rgba(100, 130, 2, 0.4);\n  display: flex;\n  align-items: center;\n  line-height: 1.2;\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n\n.ta-row-track {\n  flex: 0 0 var(--ta-track-breite);\n  width: var(--ta-track-breite);\n  position: relative;\n  min-height: 30px;\n  border-bottom: 1px solid rgba(100, 130, 2, 0.25);\n  /* Stundenraster: kräftige Linie pro Stunde, zarte Linie pro halbe Stunde */\n  background-image:\n    repeating-linear-gradient(\n      to right,\n      rgba(100, 130, 2, 0.28) 0,\n      rgba(100, 130, 2, 0.28) 1px,\n      transparent 1px,\n      transparent calc(var(--ta-track-breite) / 17)\n    ),\n    repeating-linear-gradient(\n      to right,\n      transparent 0,\n      transparent calc(var(--ta-track-breite) / 34 - 1px),\n      rgba(100, 130, 2, 0.12) calc(var(--ta-track-breite) / 34 - 1px),\n      rgba(100, 130, 2, 0.12) calc(var(--ta-track-breite) / 34)\n    );\n}\n\n/* ─── Kopfzeile ─── */\n\n.ta-header-row .ta-header-label {\n  font-size: 0.75em;\n}\n\n.ta-header-track {\n  min-height: 26px;\n  background-image: none;\n}\n\n.ta-stunde {\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.7em;\n  font-weight: bold;\n  color: var(--dunkelgruen);\n}\n\n.ta-header-row .ta-row-label,\n.ta-header-track {\n  border-bottom: 2px solid rgba(100, 130, 2, 0.4);\n}\n\n/* ─── Zeitslots ─── */\n\n.ta-body {\n  position: relative;\n}\n\n.ta-slot {\n  position: absolute;\n  top: 4px;\n  bottom: 4px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.ta-slot-label {\n  font-family: 'Circular', sans-serif;\n  font-size: 0.62em;\n  font-weight: bold;\n  color: #fff;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-shadow: 0 0 3px rgba(0, 0, 0, 0.55);\n}\n\n/* ─── Roter \"Jetzt\"-Balken über die ganze Tabelle ─── */\n\n.ta-jetzt-overlay {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: var(--ta-label-breite);\n  width: var(--ta-track-breite);\n  pointer-events: none;\n  z-index: 2;\n}\n\n.ta-jetzt-balken {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  margin-left: -1.5px;\n  background-color: #e11515;\n  box-shadow: 0 0 6px rgba(225, 21, 21, 0.6);\n}\n\n.ta-jetzt-balken::before {\n  content: '';\n  position: absolute;\n  top: -1px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 8px solid #e11515;\n}\n\n/* ─── Leer-Zustand ─── */\n\n.tagesablauf-empty {\n  text-align: center;\n  padding: 40px 20px;\n  color: var(--primary-dark);\n  font-family: 'Circular', sans-serif;\n}\n\n.tagesablauf-empty .material-symbols-outlined {\n  font-size: 3rem;\n  margin-bottom: 10px;\n  opacity: 0.5;\n}\n\n.tagesablauf-empty p {\n  font-size: 0.95em;\n}\n\n/* Auf schmalen Bildschirmen bleibt die Tabelle horizontal scrollbar,\n   die Beschriftungsspalte wird etwas schmaler */\n@media (max-width: 600px) {\n  .ta-chart {\n    --ta-label-breite: 110px;\n    --ta-track-breite: 680px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
